import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { InstructionList } from "../types";

import {
  addInstruction,
  approveInstruction,
  rejectInstruction,
} from "../../blRequestInstruction/components/actions/Instruction";
import { addTruckerDetails,   bulkPaymentProcessConfig,   getCoreror, getLinerConfigByFieldName, getTruckerDetails, updateTruckerDetails } from "../actions/instruction";
import { getOBLDetails } from "../actions/instruction";
import { act } from "react-dom/test-utils";

interface IInstructionList {
  list: InstructionList[];
  next: string | null;
  previous: string | null;
}

interface InstructionSlice {
  data: IInstructionList;
  dataObl:any;
  dataLoading: boolean;
  showColumnSettings: boolean;
  addInstruction: boolean;
  approveInstruction: boolean;
  rejectInstruction: boolean;
  linerConfig: any;
}

const initialState: InstructionSlice = {
  data: {
    next: null,
    previous: null,
    list: [],
  },
    dataObl: {
    next: null,
    previous: null,
    list: [],
  },
  dataLoading: true,
  showColumnSettings: false,
  addInstruction: false,
  approveInstruction: false,
  rejectInstruction: false,
  linerConfig: {}
};

export const instructionSlice = createSlice({
  name: "instruction",
  initialState,
  reducers: {
    toggleAddInstruction: (state, action: PayloadAction<boolean>) => {
      state.addInstruction = action.payload;
    },
    toggleApproveInstruction: (state, action: PayloadAction<boolean>) => {
      state.approveInstruction = action.payload;
    },
    togglerejectInstruction: (state, action: PayloadAction<boolean>) => {
      state.rejectInstruction = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addInstruction.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(addInstruction.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
       builder.addCase(bulkPaymentProcessConfig.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(bulkPaymentProcessConfig.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(addTruckerDetails.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(addTruckerDetails.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(approveInstruction.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(approveInstruction.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(rejectInstruction.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(rejectInstruction.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getCoreror.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getCoreror.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getTruckerDetails.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getTruckerDetails.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateTruckerDetails.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(updateTruckerDetails.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getOBLDetails.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getOBLDetails.fulfilled, (state: any, action) => {
      state.dataLoading = false;

      state.data = action.payload;
       state.dataObl = action.payload;
    });
    builder.addCase(getLinerConfigByFieldName.fulfilled, (state, action) => {
      const { data, uniqueKey } = action.payload??{data:[],uniqueKey:''};
      if (!uniqueKey || !Array.isArray(data)) {
        return;
      }
      
      const configMap = data.reduce((acc: Record<string, any>, element: any) => {
        const { fieldType, fieldValue } = element;
        
        if (!fieldType) {
          console.warn('Skipping element with invalid fieldType:', element);
          return acc;
        }
        
        if (fieldType in acc) {
          console.error('Duplicate key for', fieldType);
          return acc;
        }
        
        acc[fieldType] = fieldValue;
        return acc;
      }, {});
      
      state.linerConfig = {
        ...state.linerConfig,
        [uniqueKey as string]: configMap
      };
    });
  },
});

export const { toggleAddInstruction, toggleApproveInstruction } =
  instructionSlice.actions;

export default instructionSlice.reducer;
